module.exports = __webpack_public_path__ + "img/6.c7ddb11f.jpg";